<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Thống kê số lượng nhân sự tại các CSGD</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Năm</nz-form-label>
          <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
            nzPlaceHolder="Nhập năm" (nzOnOpenChange)="changeYear()"></nz-date-picker>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Phương thức giáo dục</nz-form-label>
          <asc-autocomplete [ascModel]="ModesOfEducationControl" (ascModelChange)="changeModesOfEducation($event)"
            placeholder="Chọn loại phương thức giáo dục..." [getListAC]="getModesOfEducation">
          </asc-autocomplete>
        </nz-form-item>
      </div>

      <ng-container *ngIf="!isCollapse">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
            <asc-autocomplete [ascModel]="PositionControl" (ascModelChange)="changePosition($event)"
              placeholder="Chọn loại nhân sự..." [getListAC]="getPositionACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table [nzShowTotal]="rangeTemplate" nzShowSizeChanger [nzLoading]="loading" [nzData]="dataTable"
      nzSize="small" [nzFrontPagination]="false" class="w-full absolute" [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions" [nzTotal]="Total"
      [nzScroll]="{x: width +'px', y: height + 'px'}" (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" rowspan="4" nzLeft>STT
          </th>
          <th rowspan="4" nzWidth="160px" nzLeft>Loại nhân sự</th>
          <th rowspan="4" class="text-center" nzWidth="50px" nzLeft>Tổng</th>
          <ng-container *ngFor="let item of dataHeader1">
            <th class="text-center" [rowspan]="item.rowSpan ? item.rowSpan : 1"
              [colspan]="item.colSpan ? item.colSpan : 1"> {{ item.dataName }}
            </th>
          </ng-container>
        </tr>
        <tr #pageHeaderTable2>
          <ng-container *ngFor="let item of dataHeader2">
            <th class="text-center" [rowspan]="item.rowSpan ? item.rowSpan : 1"
              [colspan]="item.colSpan ? item.colSpan : 1"> {{ item.dataName }}
            </th>
          </ng-container>
        </tr>
        <tr #pageHeaderTable3>
          <ng-container *ngFor="let item of dataHeader3">
            <th class="text-center" [rowspan]="item.rowSpan ? item.rowSpan : 1"
              [colspan]="item.colSpan ? item.colSpan : 1"> {{ item.dataName }} </th>
          </ng-container>
        </tr>
        <tr #pageHeaderTable4>
            <ng-container *ngFor="let item of dataHeader3">
              <th class="text-center">
                SL
              </th>
              <th class="text-center">
                %
              </th>
            </ng-container>
          </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{data.PositionName}}</td>
          <td class="text-center" nzLeft>{{data.PositionTotal}}</td>
          <ng-container *ngFor="let key of keyIdArr">
            <td class="text-center" *ngIf="key !== ''">{{data[key]}}</td>
            <td class="text-center" *ngIf="key === ''"></td>
            <td class="text-center">{{ data[key] && data.PositionTotal? (data[key] * 100 / data.PositionTotal | number:'1.2-2')  : 0}}</td>
          </ng-container>
        </tr>
        <tr>
          <td nzLeft></td>
          <td nzLeft>{{'Tổng'}}</td>
          <td class="text-center" nzLeft><b>{{totalTong}}</b></td>
          <ng-container *ngFor="let key of keyIdArr">
            <td class="text-center" *ngIf="key !== ''"><b>{{reportObject[key]}}</b></td>
            <td class="text-center" *ngIf="key === ''"></td>
            <td class="text-center" [nz-tooltip]="(reportObject[key] * 100 / totalTong | number:'1.2-2') + '%'">{{ reportObject[key] && totalTong? (reportObject[key] * 100 / totalTong | number:'1.2-2')  : 0}}</td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
